import * as ActionType from "./serviceProviderRequest.type";

const initialState = {
  serviceProviderRequest: [],
};

export const serviceProviderRequestReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.GET_SERVICE_PROVIDER_REQUEST:
      return {
        ...state,
        serviceProviderRequest: action.payload,
      };
    case ActionType.ACCEPT_SERVICE_PROVIDER_REQUEST:
      return {
        ...state,
        serviceProviderRequest: state.serviceProviderRequest.filter(
          (data) => data._id !== action.payload
        ),
      };
    case ActionType.REJECT_SERVICE_PROVIDER_REQUEST:
      return {
        ...state,
        serviceProviderRequest: state.serviceProviderRequest.filter(
          (data) => data._id !== action.payload
        ),
      };
    default:
      return state;
  }
};
